import { StyleProp, TouchableOpacity, ViewStyle } from 'react-native';
import { View } from '@shared/components/View';
import { MBIcon, MBImageURISource } from '@shared/components/image';

interface MBModalButtonProps {
  onPress: () => void;
  icon: MBImageURISource;
  color: string;
  style?: StyleProp<ViewStyle>;
  testID?: string;
}

/*
    Component to DRY up logic for default back and close buttons for web modals.
*/
export function MBModalButton({ icon, color, style, onPress, testID }: MBModalButtonProps) {
  return (
    <TouchableOpacity style={style} onPress={onPress} testID={testID}>
      <View padding={1}>
        <MBIcon source={icon} color={color} style={{ padding: 6 }} />
      </View>
    </TouchableOpacity>
  );
}
